import React from 'react'

const FCOutStanding = () => {
  return (
    <div>FCOutStanding</div>
  )
}

export default FCOutStanding